import { Component, ErrorInfo, ReactNode } from 'react'
import { AlertTriangle, RotateCcw } from 'lucide-react'

interface Props { children: ReactNode }
interface State { hasError: boolean; error?: Error }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-night-950 px-4">
          <div className="card max-w-md p-8 text-center">
            <AlertTriangle className="mx-auto mb-4 h-12 w-12 text-primary-500" aria-hidden />
            <h1 className="font-display text-xl font-bold text-white">Une erreur est survenue</h1>
            <p className="mt-2 text-sm text-night-300">
              L'application a rencontré un problème inattendu. Rechargez la page pour continuer.
            </p>
            {import.meta.env.DEV && this.state.error && (
              <pre className="mt-4 max-h-40 overflow-auto rounded-lg bg-night-900 p-3 text-left text-xs text-red-300">
                {this.state.error.stack}
              </pre>
            )}
            <button
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
            >
              <RotateCcw className="h-4 w-4" aria-hidden /> Recharger
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
